import React, { useRef } from "react";

import { Animations } from "@/styles/utils/Mixins";

import { Background, OverlayWrapper } from "./styles";

type FullscreenOverlayProps = {
  children: React.ReactNode;
  onClose?: () => void;
  animation: Animations.FADE_IN | Animations.MOVE_UP_AND_FADE_IN;
  hasScrollbar: boolean; // false: The size of the iframe is adjusted, true: in full screen mode there is a scroll bar (nps.html, outroOverlay.html)
};

const FullscreenOverlay: React.FC<FullscreenOverlayProps> = (
  props: FullscreenOverlayProps
): React.JSX.Element => {
  const { animation, hasScrollbar = false } = props;
  const backgroundRef = useRef<HTMLDivElement>(null);

  const close = (event: React.SyntheticEvent<HTMLDivElement>) => {
    if (props.onClose && event.target === backgroundRef.current) {
      props.onClose();
    }
  };

  return (
    <Background
      ref={backgroundRef}
      onClick={close}
      className="overlay"
      data-qa={"outro"}
      $hasScrollbar={hasScrollbar}
    >
      <OverlayWrapper $animation={animation}>{props.children}</OverlayWrapper>
    </Background>
  );
};

export { FullscreenOverlay, FullscreenOverlayProps };
